import type { FC } from 'react'
import { Button } from '../Buttons/Button'
import './SteeringModeBar.css'

type SteeringModeBarProps = {
  mode: 'f2' | 'f3'
  onSwitch: () => void
}

export const SteeringModeBar: FC<SteeringModeBarProps> = ({ mode, onSwitch }) => {
  const isFeature2 = mode === 'f2'

  return (
    <section
      className={`steering-mode-bar steering-mode-bar-${mode}`}
      aria-label={`${mode.toUpperCase()} vehicle steering mode`}
    >
      <div className="steering-mode-copy">
        <div className="steering-mode-title-row">
          <h1 className="steering-mode-title">{mode.toUpperCase()} mode</h1>
          {isFeature2 ? <span className="steering-mode-legacy-label">Legacy</span> : null}
        </div>
        <p className="steering-mode-description">
          {isFeature2 ? 'Legacy charging steering' : 'Current charging steering'}
        </p>
      </div>

      <Button
        type="button"
        variant="secondary"
        size="compact"
        className="steering-mode-switch"
        onClick={onSwitch}
      >
        Switch to {isFeature2 ? 'F3' : 'F2'} VehicleSteering
      </Button>
    </section>
  )
}
